<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { getdataAmat } from './dataAmat.js';
import {
	inquiryCompanyAccount,
	getCACodeDesc,
	getaccountLevel,
	getCombo,
	saveOrUpdateCA,
	loadCA,
	deleteCompanyAccount,
	exportca,
	importcompanyaccount,
	getAccountingDate,
	getFirstLevelAccounts
} from '../../../../../api/home.js';
import uploadFileplus from '../../../../common/uploadFileplus/index.vue';
import config from '../../../../../../configHttp';
export default {
	name: 'ChineseSubjects',
	components: {
		uploadFileplus
	},
	data() {
		return {
			updiag: false,
			uploadinglist: [],
			uploadingdata: {},
			/* 搜索栏 */
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			overlength: 0,
			searchdiag: false,
			/* 搜索栏 */
			/* 表格 */
			pagination: getdata().pagination,
			headData: JSON.parse(localStorage.getItem('ChineseSubjectsheadData')) || this.projectType=='Amat'?getdataAmat().headData: getdata().headData,
			outlist: JSON.parse(localStorage.getItem('ChineseSubjectsoutlist')) || [],
			shaidiag: false,
			tableData: [],
			tablekey: 0,
			tableHeight: 'calc(100vh - 325px )',
			/* 表格 */
			// 科目弹框
			subject: false,
			formdata:this.projectType=='Amat'?getdataAmat().formdata: getdata().formdata,
			formlist:this.projectType=='Amat'?getdataAmat().formlist: getdata().formlist,
			//中方科目代码
			zfkmdm: [],
			//科目等级
			kmdj: [],
			//中方科目类型
			zfkmlx: [],
			title: '',
			Count: 0,
			upfile: {},
			sort: '',
			order: '',
			firstLevelLength: '',
			firstLevelAccounts: {}
		};
	},
	mounted() {},
	created() {
		this.acquirezfkmdmkmdjzfkmlx();
	},
	methods: {
		sortchange(data) {
			this.sort = data.prop;
			this.order = data.order == 'ascending' ? 'asc' : 'desc';
			this.searrchForData();
		},
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('ChineseSubjectsoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('ChineseSubjectsheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
			this.getCloseoutPageList();
		},
		querySearchAsync(queryString, cb) {
			var restaurants = this.zfkmdm.map(v => {
				return {
					value: v.key+"-"+v.value,
					address: v.key
				};
			});
			var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

			cb(results);
		},
		createStateFilter(queryString) {
			return state => {
				return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
			};
		},
		handleSelect(item) {
			
		},
		forsubmit(e) {
			if (this.$emptyandnull(this.upfile.upfilename)) {
				this.$message.error('请选择要上传的文件');
				return false;
			}
			let params = {};
			params.uploadFile = [];
			params.uploadFile[0] = this.upfile.upfile;
			importcompanyaccount(params).then(res => {
				if (res.data.code == '200') {
					this.closeupdiag();
					this.searrchForData();
					this.$message.success('导入成功');
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		closeupdiag() {
			this.updiag = false;
		},
		getuploadparams(e) {
			this.upfile = e;
		},
		selectionchange(e) {
			this.Count = e.length;
		},
		//导出
		derive() {
			let params = {};
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				params.ids = '';
			} else {
				params.ids = this.$refs.tablebox
					.getSelectionval()
					.map(v => v.id)
					.join(',');
			}
			let req = {
				downUrl: config.baseURL + (config.projectType == 'Amat' ? '/amat/excel/export/ca?ids=' : '/fvm/excel/export/ca?ids=') + params.ids,
				typeObj: {
					toForm: false,
					fileType: 'xls',
					fileName: '中方科目数据' + this.$timestampToStr(new Date(), 'yyyyMMdd')
				}
				// params: params
			};
			this.$downloadcommon(req);
		},
		//删除
		remove(id) {
			if (id == '-1') {
				if (this.$refs.tablebox.getSelectionval().length == 0) {
					this.$message.error('请选择要删除的数据');
					return;
				}
				this.$showConfirm({
					message: '确认删除?'
				}).then(res => {
					if (res == 'confirm') {
						let params = {
							ids: this.$refs.tablebox
								.getSelectionval()
								.map(v => v.id)
								.join(',')
						};
						deleteCompanyAccount(params).then(res => {
							if (res.data.code == '200') {
								this.$message.success('删除成功');
								this.acquirezfkmdmkmdjzfkmlx();
							} else {
								this.$message.error(res.data.message);
							}
						});
					}
				});
			} else {
				this.$showConfirm({
					message: '确认删除?'
				}).then(res => {
					if (res == 'confirm') {
						let params = { ids: id };
						deleteCompanyAccount(params).then(res => {
							if (res.data.code == '200') {
								this.$message.success('删除成功');
								this.acquirezfkmdmkmdjzfkmlx();
							} else {
								this.$message.error(res.data.message);
							}
						});
					}
				});
			}
		},
		//保存
		getdata(e) {
			this.$delete(this.formdata, 'rootAcountId');
			this.$delete(this.formdata, 'parentAccountId');
			this.$delete(this.formdata, 'createDate');
			this.$delete(this.formdata, 'updateDate');
			let params = this.formdata;
			saveOrUpdateCA(params).then(res => {
				if (res.data.code == '200') {
					this.$message.success('保存成功');
					this.acquirezfkmdmkmdjzfkmlx();
					this.subject = false;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		//校验
		baocunjiaoy() {
			this.$refs.taxform.submitForm();
		},
		//唤起弹框
		subjecttk(id) {
			getFirstLevelAccounts().then(res => {
				if (res.data.code == '200') {
					this.firstLevelAccounts = res.data.data;
				}
			});
			this.formlist[1].disabled = false;
			this.projectType=='Amat' ? this.formlist[8].disabled = false : this.formlist[7].disabled = false;

			this.formlist[0].selectval = this.zfkmdm.map(v => {
				return {
					label: v.key,
					value: v.key
				};
			});
			this.formlist[1].selectval = this.zfkmlx.map(v => {
				return {
					label: v.value,
					value: v.idx
				};
			});
			this.formlist[2].selectval = this.kmdj.map(v => {
				return {
					label: v.value,
					value: v.value
				};
			});
			this.formdata = getdata().formdata;
			this.formdata.id = id;
			if (id == '-1') {
				this.title = '新建中方科目';

				this.subject = true;
				//如果当前公司引用账套已设置了年结科目，后续新增中方科目时 “是否年结科目”都 默认为 否
				getAccountingDate().then(res => {
					if(res.data.code == '200' && res.data.data == true){
						this.formdata.accountingDate = "0";
					}
				});
			} else {
				this.title = '编辑中方科目';
				loadCA({ id: id }).then(res => {
					if (res.data.code == '200') {
						this.formdata = res.data.data;
						this.formdata.id = id;
						this.subject = true;
						if(this.formdata.accountCode.length > this.firstLevelLength){
							this.formlist[1].disabled = true;
							this.projectType=='Amat' ? this.formlist[8].disabled = true : this.formlist[7].disabled = true;
						}
					} else {
						this.$message.error(res.data.message);
					}
				});
			}

			this.$nextTick(() => {
				this.$refs['taxform'].clearValidate();
			});
		},
		//获取中方科目代码  科目等级 中方科目类型
		acquirezfkmdmkmdjzfkmlx() {
			let params = {};
			params.likeSearch = '';
			params.isLastLevel = false;
			getCACodeDesc(params).then(res => {
				if (res.data.code == '200') {
					this.zfkmdm = res.data.data;
					getaccountLevel().then(res2 => {
						if (res2.data.code == '200') {
							this.kmdj = res2.data.data.map(v => {
								return {
									label: v.value,
									value: v.value
								};
							});
							this.firstLevelLength = res2.data.data[0].key.substr(res2.data.data[0].key.indexOf(",") + 1);
							params = { name: 'FV_VOUCHER_ACCOUNT_TYPE' };
							getCombo(params).then(res3 => {
								this.zfkmlx = res3.data.data;
								this.searchlist = getdata().searchlist;
								this.searchlist[1].selectval = res3.data.data.map(v => {
									return {
										label: v.value,
										value: v.idx
									};
								});
								this.searrchForData();
							});
						}
					});
				}
			});
		},
		searrchForData() {
			let params = {};
			params.criteriaJson = JSON.stringify(this.searchdata);
			params.page = this.pagination.pageNum;
			params.rows = this.pagination.pageSize;
			params.sort = this.sort;
			params.order = this.order;
			inquiryCompanyAccount(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data;
					this.pagination.total = res.data.count;
				}
			});
		},
		/* 搜索栏 */
		geOoverLength(e) {
			this.overlength = e;
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.searrchForData();
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		/* 搜索栏 */
		/* 表格 */
		currentChange(e) {
			this.pagination.pageNum = e;
			this.searrchForData();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.searrchForData();
		},
		/* 表格 */
		accountCodeChange(){
			let accountCode = this.formdata.accountCode;
			const index = accountCode.indexOf("-");
			if(index != -1){
				this.formdata.accountCode = accountCode.substr(0,index);
				this.formdata.accountDesc = accountCode.substr(index + 1) + "-";
			}
			if(this.formdata.accountCode.length > this.firstLevelLength){
				let firstLevelAccount = this.firstLevelAccounts[this.formdata.accountCode.substr(0,4)];
				if(firstLevelAccount){
					this.formlist[1].disabled = true;
					this.projectType=='Amat' ? this.formlist[8].disabled = true : this.formlist[7].disabled = true;
					this.formdata.accountType = firstLevelAccount.accountType;
					this.formdata.debitCreditType = firstLevelAccount.debitCreditType;
				}
			} else{
				this.formlist[1].disabled = false;
				this.projectType=='Amat' ? this.formlist[8].disabled = false : this.formlist[7].disabled = false;
			}
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
